import React, { Component } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";
import CustomBreadcrumbs from "../../../../../components/Common/CustomBreadcrumbs";
import ModifiedMetaTags from '../../../../../components/ModifiedMetaTags/index';

class ClientFinanceReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        results: [
          {
            client: "Joom",
            payouts: "100,000$",
            r_amounts: "99,600$",
            bank_fee: "40,000$",
            due_date: "31-01-2022",
            r_date: "27-01-2022",
          },
        ],
      },
      columns: [
        {
          Header: "Client",
          accessor: "client",
          isSorted: true,
        },
        {
          Header: "Payouts",
          accessor: "payouts",
          isSorted: true,
        },
        {
          Header: "Received Amounts",
          accessor: "r_amounts",
          isSorted: true,
        },
        {
          Header: "Bank Fee",
          accessor: "bank_fee",
          isSorted: true,
        },
        {
          Header: "Due Date",
          accessor: "due_date",
          isSorted: true,
        },
        {
          Header: "Received Date",
          accessor: "r_date",
          isSorted: true,
        },
      ],
      breadcrumbs: [
        {
          link: `/finance-report`,
          title: "All clients",
        },
        {
          title: this.props.match.params.client,
        },
      ],
    };
  }

  componentDidMount() {
    const client = this.props.match.params.client;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <React.Fragment>
          <div className="page-content">
          <ModifiedMetaTags title={`${this.props.match.params.client || 'Client'} | Mobihunter`} />

            <Container fluid>
              <Breadcrumbs
                title="Dashboard"
                breadcrumbItem={this.props.match.params.client}
                link={`/finance-report/${this.props.match.params.client}`}
              />

              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <Row className="justify-content-between align-middle">
                        <Col xs={6}>
                          <CustomBreadcrumbs
                            breadcrumbItem={this.state.breadcrumbs}
                          />
                        </Col>
                      </Row>
                      <ReactTableForm
                        columns={this.state.columns}
                        data={this.state.data}
                        onTableChange={this.onTableChange}
                        //loading={this.props.loading}
                        //pagination
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      </>
    );
  }
}

ClientFinanceReport.propTypes = {
  history: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      client: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {})(ClientFinanceReport);
